import { Text, VStack, Box, Button, Stack } from "@chakra-ui/react";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { HomeIcon } from "../../customIcons";

const HeroSection = ({
  title,
  description,
  heightSize,
  isSearch,
  is404,
  isComingSoon,
  marginBottom,
}: any) => {
  return (
    <Box position="relative" h={heightSize} w="100%" mb={marginBottom}>
      <StaticImage
        src="../../../images/hero_bg.webp"
        alt="hero bg image"
        layout="fullWidth"
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
          objectPosition: "center",
          backgroundColor: "transparent !important",
          position: "absolute",
        }}
        placeholder="none"
        loading="lazy"
        quality={100}
      />
      <VStack
        gap={0}
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        alignItems="flex-start"
        justify="center"
        mx="auto"
        zIndex={1}
        maxW="1280px"
        w="100%"
        px={{ base: 4, "2xl": 0 }}
        py={{ base: 12, md: 24 }}
      >
        {is404 ? (
          <Text
            color="#116266"
            className="grotesk-medium"
            fontSize={{ base: "64px", sm: "72px", md: "90px", xl: "120px" }}
            lineHeight="90%"
            pb={4}
            as="h1"
          >
            404
            <Text
              maxW={{ base: "288px", sm: "448px", md: "600px" }}
              pb={5}
              lineHeight="100%"
              className="light-text"
              fontSize={{ base: "48px", md: "72px" }}
              color="#1B1E1E"
              as="h1"
            >
              {title}
            </Text>
          </Text>
        ) : (
          <Text
            maxW={{ base: "288px", sm: "448px", md: "600px" }}
            pb={5}
            lineHeight="100%"
            className="light-text"
            fontSize={{ base: "48px", md: "72px" }}
            color="#1B1E1E"
            as="h1"
          >
            {title}
          </Text>
        )}

        <Text
          maxW="600px"
          color="#6A7471"
          className="regular-text"
          fontSize="18px"
          lineHeight="150%"
          pb={isSearch ? 10 : 0}
        >
          {description}{" "}
          {is404 && (
            <a
              style={{
                color: "#116266",
                textDecoration: "underline",
                textUnderlineOffset: "4px",
              }}
              href="/contact-us"
            >
              contact us.
            </a>
          )}
        </Text>
        {/* {isSearch && (
          <InputGroup maxW={{ base: "100%", md: "450px" }}>
            <InputLeftElement
              mt={1}
              pointerEvents="none"
              children={<SearchLine />}
            />
            <Input
              type="text"
              h="48px"
              placeholder="Search"
              _placeholder={{ color: "#6A7471", fontWeight: "bold" }}
              className="regular-text"
              borderRadius="full"
              borderColor="#6A7471"
              _hover={{ borderColor: "gray.400" }}
              _focus={{
                borderColor: "#116266",
              }}
            />
          </InputGroup>
        )} */}
        {is404 && (
          <Stack pt={10} w="100%">
            <a href="/">
              <Button
                h="48px"
                color="#fff"
                fontSize="18px"
                _hover={{ bg: "#4C9195" }}
                className="medium-text"
                bg="#116266"
                borderRadius="9999px"
                w={{ base: "100%", md: "241px" }}
                leftIcon={<HomeIcon w="16px" h="16px" />}
              >
                Back to Home Page
              </Button>
            </a>
          </Stack>
        )}
        {isComingSoon && (
          <Stack pt={10} w="100%">
            <a href="/contact-us">
              <Button
                h="48px"
                color="#fff"
                fontSize="18px"
                _hover={{ bg: "#4C9195" }}
                className="medium-text"
                bg="#116266"
                borderRadius="9999px"
                w={{ base: "100%", md: "147px" }}
              >
                Contact Us
              </Button>
            </a>
          </Stack>
        )}
      </VStack>
    </Box>
  );
};

export default HeroSection;
